// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"460":"HomePage","728":"RecipePage"}[chunkId] || chunkId) + "." + {"266":"f0c33bb5","460":"875a6296","728":"0b92f9cd"}[chunkId] + ".chunk.js";
};